export default __webpack_public_path__ + "static/media/pantry1-afterC-1024w.35a37a2d.png";